import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { AccessResult, hasAdminAccess, NO_ACCESS_MESSAGE } from "utils/access";
import { AccountContext } from "views/AccountWrapper";

type ScanForUpdate = {
  space: { id: string };
};

const useCanUpdateScan = (): ((scan?: ScanForUpdate) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (scan?: ScanForUpdate) => {
      if (!scan) {
        return { result: false };
      }

      if (viewer.admin) {
        return { result: true };
      }

      if (hasAdminAccess(viewer, scan.space.id)) {
        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useCanUpdateScan;
